import React from 'react';
import classNames from 'classnames';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import RecebivelDiscountSection from '../sections/RecebivelDiscountSection.jsx';
import RecebivelDueDateSection from '../sections/RecebivelDueDateSection.jsx';
import RecebivelMainFields from '../sections/RecebivelMainFields.jsx';

/**
 * @typedef {object} RecebivelCreateDialogProps
 * @property {boolean} visible
 * @property {() => void} onClose
 * @property {() => void} onOpenSimulacao
 * @property {(event: React.FormEvent<HTMLFormElement>) => void} onSubmit
 * @property {object} formState
 * @property {string|number} formState.recebivelTipoId
 * @property {{label: string, value: string|number}[]} formState.recebivelTipos
 * @property {number|string|null} formState.recebivelTipoValor
 * @property {Date|string|null} formState.recebivelTipoDataInicio
 * @property {Date|string|null} formState.recebivelTipoDataFim
 * @property {string} formState.recebivelTipoDescontoTipo
 * @property {string|number|null} formState.recebivelTipoDesconto
 * @property {number|string|null} formState.recebivelTipoVencimento
 * @property {string} formState.periodicidade
 * @property {{setRecebivelTipoId: Function, setRecebivelTipoValor: Function, setRecebivelTipoDataInicio: Function, setRecebivelTipoDataFim: Function, setRecebivelTipoDescontoTipo: Function, setRecebivelTipoDesconto: Function, setRecebivelTipoVencimento: Function, setPeriodicidade: Function}} actions
 * @property {{label: string, value: string}[]} descontoOptions
 */

/**
 * Dialog de cadastro de boleto inteligente.
 *
 * @param {RecebivelCreateDialogProps} props
 * @returns {JSX.Element}
 */
export default function RecebivelCreateDialog(props) {
    const {
        visible,
        onClose,
        onOpenSimulacao,
        onSubmit,
        formState,
        actions,
        descontoOptions,
    } = props;

    return (
        <Dialog
            header='Cadastrar Boleto Inteligente'
            visible={visible}
            onHide={onClose}
            pt={{
                root: 'w-screen md:w-[50vw] max-h-[100vh]',
                header: classNames('flex items-center justify-between shrink-0',
                    'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                    'dark:bg-gray-900  dark:text-white/80'),
                content: ({ state }) => ({
                    className: classNames('overflow-auto w-full max-h-[85vh]',
                        'bg-white text-gray-700 px-6 pb-8 pt-0',
                        'rounded-bl-lg rounded-br-lg',
                        'dark:bg-gray-900 dark:text-white/80 ', {
                        'grow': state.maximized
                    })
                }),
            }}
        >
            <div className="w-full flex items-center justify-center">
                <div className="w-full md:w-2/3 lg:w-1/3">
                    <Button
                        className='w-full'
                        severity='info'
                        label="Simular Parcela"
                        onClick={onOpenSimulacao}
                        rounded
                    />
                </div>
            </div>
            <form onSubmit={onSubmit}>
                <div className="flex flex-wrap justify-between gap-2 mt-3">
                    <RecebivelMainFields
                        recebivelTipoId={formState.recebivelTipoId}
                        recebivelTipos={formState.recebivelTipos}
                        setRecebivelTipoId={actions.setRecebivelTipoId}
                        recebivelTipoValor={formState.recebivelTipoValor}
                        setRecebivelTipoValor={actions.setRecebivelTipoValor}
                        recebivelTipoDataInicio={formState.recebivelTipoDataInicio}
                        setRecebivelTipoDataInicio={actions.setRecebivelTipoDataInicio}
                        recebivelTipoDataFim={formState.recebivelTipoDataFim}
                        setRecebivelTipoDataFim={actions.setRecebivelTipoDataFim}
                    />
                    <RecebivelDiscountSection
                        recebivelTipoDescontoTipo={formState.recebivelTipoDescontoTipo}
                        setRecebivelTipoDescontoTipo={actions.setRecebivelTipoDescontoTipo}
                        recebivelTipoDesconto={formState.recebivelTipoDesconto}
                        setRecebivelTipoDesconto={actions.setRecebivelTipoDesconto}
                        descontoOptions={descontoOptions}
                    />
                    <RecebivelDueDateSection
                        recebivelTipoVencimento={formState.recebivelTipoVencimento}
                        setRecebivelTipoVencimento={actions.setRecebivelTipoVencimento}
                        periodicidade={formState.periodicidade}
                        setPeriodicidade={actions.setPeriodicidade}
                    />

                    <div className="w-full flex items-center justify-center">
                        <div className="w-full md:w-2/3 lg:w-1/3 mt-3">
                            <Button
                                className="w-full"
                                label="Enviar"
                                type="submit"
                                severity='success'
                            />
                        </div>
                    </div>
                </div>
            </form>
        </Dialog>
    );
}
